module.exports = __webpack_public_path__ + "quilt2-level1.c1785753.png";